import { render, staticRenderFns } from "./Persona.vue?vue&type=template&id=7008d2b3&"
import script from "./Persona.vue?vue&type=script&lang=js&"
export * from "./Persona.vue?vue&type=script&lang=js&"
import style0 from "./Persona.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports